export function scrollToHash(hash) {
  const h = hash || window.location.hash;
  if (h && h.length > 1) {
    const el = document.querySelector(h);
    if (el) {
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
      else el.scrollIntoView({ behavior: "smooth" });
      return true;
    }
  }
  return false;
}

export function scrollToTop() {
  if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
}
